import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: false,
  dateSearch: {
    start: '',
    end: '',
  },
  response: {
    path: '',
    status: false,
  },
};

export const getcashInDownloadFromApi = createAction(
  '@CASHIN/DOWNLOAD/GET_DOWNLOAD_DATA_FROM_API'
);

export const disableCashInDownloadFromApi = createAction(
  '@CASHIN/DOWNLOAD/GET_DOWNLOAD_DATA_FROM_DISABLE_API'
);

export const gotcashInDownloadFromApi = createAction<any>(
  '@CASHIN/DOWNLOAD/GOT_DOWNLOAD_DATA_FROM_API'
);

export const gotErrorFromcashInDownloadApi = createAction(
  '@CASHIN/DOWNLOAD/GOT_ERROR_FROM_DOWNLOAD_DATA_API'
);

const cashInDownloadReducer = createReducer(INITIAL_STATE, {
  [getcashInDownloadFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: true,
  }),
  [disableCashInDownloadFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    gotSuccess: false,
    partner: false,
    gotError: false,
    isLoading: false,
  }),
  [gotcashInDownloadFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    isLoading: false,
    gotError: false,
    partner: false,
    response: {
      path: action.payload.path,
      status: action.payload.status,
    },
  }),

  [gotErrorFromcashInDownloadApi.type]: (state) => ({
    ...state,
    gotSuccess: false,
    isLoading: false,
    partner: false,
    gotError: true,
  }),
});

export default cashInDownloadReducer;
